import { BodyLG, BodySM } from "../../../typography";
import {
  faArrowRight,
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MOBILE_MENU_ANIMATION_DURATION } from "../config/navConfig";
import { NavItem } from "../config/navConfig";
import { NavLink } from "./NavLink";
import { cn } from "@verse_core/shared_components/ClassName";
import { useDropdown } from "../hooks/useDropdown";

interface MobileNavItemProps extends NavItem {
  onCloseMobileMenu: () => void;
}

export const MobileNavItem = ({
  href,
  title,
  dropdownItems,
  onCloseMobileMenu,
}: MobileNavItemProps) => {
  const isDropdown = !!dropdownItems;
  const { isOpen, ref, toggleDropdown } = useDropdown();

  return (
    <div className="tw-flex tw-min-h-[3em] tw-w-full tw-items-center tw-justify-between tw-px-[1em]">
      {href ? (
        <NavLink href={href} className="tw-w-full" onClick={onCloseMobileMenu}>
          <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-[.5em]">
            <BodyLG className="tw-mb-0 tw-text-black">{title}</BodyLG>
          </div>
        </NavLink>
      ) : (
        <div className="tw-w-full" ref={ref} onClick={toggleDropdown}>
          <div className="tw-flex tw-min-h-[48px] tw-items-center tw-justify-between tw-gap-x-[8px]">
            <BodyLG className="tw-mb-0 tw-text-black">{title}</BodyLG>
            {isDropdown && (
              <FontAwesomeIcon
                icon={isOpen ? faChevronUp : faChevronDown}
                className="tw-h-[16px] tw-w-[16px] tw-text-gray-4"
              />
            )}
          </div>
          <div
            className={cn(
              `tw-grid tw-transition-[grid-template-rows] tw-duration-${MOBILE_MENU_ANIMATION_DURATION}`,
              isOpen ? "tw-grid-rows-[1fr]" : "tw-grid-rows-[0fr]",
            )}
          >
            <div className="tw-overflow-hidden">
              <div className="tw-flex tw-flex-col tw-bg-white">
                {dropdownItems?.map((item) => (
                  <NavLink
                    key={item.title}
                    href={item.href}
                    className="tw-flex tw-items-start tw-gap-x-[8px] tw-py-[12px] hover:tw-bg-gray-light-4"
                    onClick={onCloseMobileMenu}
                  >
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="tw-mt-[3px] tw-h-[14px] tw-w-[13px] tw-text-blue-1"
                    />
                    <div className="tw-flex tw-flex-col">
                      <BodyLG className="tw-mb-0 tw-text-black">
                        {item.title}
                      </BodyLG>
                      <BodySM className="tw-mb-0 tw-text-gray-3">
                        {item.description}
                      </BodySM>
                    </div>
                  </NavLink>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
